import SuperAdminLayout from "@/layouts/SuperAdminLayout";
import { AuthenticatedShell } from "./authenticatedShell.tsx";
import { AppDialogsProvider } from "@/context/dialogs";
import { SupportAdminRoleGate } from "../supportAdminRoleGate";
import { MeProvider } from "@/context/me/MeProvider";

export const SuperAdminShell = () => (
  <AuthenticatedShell>
    <MeProvider>
      <SupportAdminRoleGate>
        <AppDialogsProvider>
          <SuperAdminLayout />
        </AppDialogsProvider>
      </SupportAdminRoleGate>
    </MeProvider>
  </AuthenticatedShell>
);
